/**
 * Copyright (C) SiteVision AB 2002-2025, all rights reserved
 *
 * HTML template utils (micro version of _.template)
 *
 * @author Henrik Ekelöf
 *
 */
import sv from '@sv/core';
import $ from '@sv/jquery';

export const htmlEncode = function (value) {
  //create a in-memory div, set it's inner text(which jQuery automatically encodes)
  //then grab the encoded contents back out.  The div never exists on the page.
  return $('<div/>').text(value).html();
};

sv.TemplateUtil = {
  htmlEncode,
};
